var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Button, Card, CardContent, Dialog, DialogContent, DialogTitle, DialogActions, Grid, IconButton, Chip, CircularProgress } from "@mui/material";
import { inject, observer } from "mobx-react";
import React from "react";
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import TimerIcon from '@mui/icons-material/Timer';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DateTime, Duration } from "luxon";
var VideoGallery = /** @class */ (function (_super) {
    __extends(VideoGallery, _super);
    function VideoGallery(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    Object.defineProperty(VideoGallery.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a, _b, _c, _d;
            if (((_a = this.props.recordingStore) === null || _a === void 0 ? void 0 : _a.isRecording) && !((_b = this.props.recordingStore) === null || _b === void 0 ? void 0 : _b.isPaused))
                return this.renderRecordingStatus();
            if ((_c = this.props.recordingStore) === null || _c === void 0 ? void 0 : _c.isBusy)
                return this.renderBusy();
            var recordings = (_d = this.props.recordingStore) === null || _d === void 0 ? void 0 : _d.recordings;
            if (!recordings || recordings.length === 0)
                return this.renderEmpty();
            return (_jsxs(Grid, __assign({ container: true, direction: "row" }, { children: [this.renderConfirmDeleteDialog(), recordings.map(function (v, i) { return _this.renderPlaybackControl(i, v); })] }), void 0));
        }
    });
    Object.defineProperty(VideoGallery.prototype, "renderPlaybackControl", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (index, attachment) {
            if (attachment.name.endsWith('.mp3')) {
                return this.renderAudioControl(index, attachment);
            }
            else if (attachment.name.endsWith('.mp4')) {
                return this.renderVideoControl(index, attachment);
            }
        }
    });
    Object.defineProperty(VideoGallery.prototype, "renderAudioControl", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (index, audio) {
            var _this = this;
            var _a, _b;
            var createdAt = DateTime.fromISO(audio.createdAt, { zone: 'UTC' }).toLocal();
            var adapter = new AdapterDateFns();
            adapter.locale = (_a = this.props.languageStore) === null || _a === void 0 ? void 0 : _a.getMuiLocale();
            var dateTime = adapter.formatByString(createdAt.toJSDate(), 'P HH:mm');
            var duration = Duration.fromMillis(audio.durationMs).toFormat('mm:ss');
            return (_jsxs(Grid, __assign({ item: true, container: true, direction: "column", sx: { width: 'unset !important' } }, { children: [_jsxs(Grid, __assign({ item: true, container: true, alignItems: "center", justifyContent: "space-between", sx: { paddingBottom: '10px' } }, { children: [_jsxs(Grid, __assign({ item: true }, { children: [_jsx(Chip, { label: dateTime, color: "primary", variant: "outlined", icon: _jsx(CalendarMonthIcon, {}, void 0), sx: { marginRight: '5px' } }, void 0), _jsx(Chip, { label: duration, color: "primary", variant: "outlined", icon: _jsx(TimerIcon, {}, void 0), sx: { marginRight: '5px' } }, void 0)] }), void 0), _jsxs(Grid, __assign({ item: true }, { children: [_jsx(IconButton, __assign({ color: "primary", onClick: function () { return _this.onDownloadAttachmentClick(audio); }, sx: { marginRight: '5px' } }, { children: _jsx(SaveIcon, {}, void 0) }), void 0), ((_b = this.props.recordingStore) === null || _b === void 0 ? void 0 : _b.isRecording) ?
                                        null :
                                        _jsx(IconButton, __assign({ color: "primary", onClick: function () { return _this.onDeleteAttachmentClick(audio); }, sx: { marginRight: '5px' } }, { children: _jsx(DeleteIcon, {}, void 0) }), void 0)] }), void 0)] }), void 0), _jsx(Grid, __assign({ item: true }, { children: _jsx("audio", __assign({ controls: true, autoPlay: false, style: {
                                marginRight: '15px'
                            } }, { children: _jsx("source", { src: audio.url }, void 0) }), void 0) }), void 0)] }), index));
        }
    });
    Object.defineProperty(VideoGallery.prototype, "renderVideoControl", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (index, video) {
            var _this = this;
            var _a, _b;
            var createdAt = DateTime.fromISO(video.createdAt, { zone: 'UTC' }).toLocal();
            var adapter = new AdapterDateFns();
            adapter.locale = (_a = this.props.languageStore) === null || _a === void 0 ? void 0 : _a.getMuiLocale();
            var dateTime = adapter.formatByString(createdAt.toJSDate(), 'P HH:mm');
            var duration = Duration.fromMillis(video.durationMs).toFormat('mm:ss');
            return (_jsxs(Grid, __assign({ item: true, container: true, direction: "column", sx: { width: 'unset !important' } }, { children: [_jsxs(Grid, __assign({ item: true, container: true, alignItems: "center", justifyContent: "space-between", sx: { paddingBottom: '10px' } }, { children: [_jsxs(Grid, __assign({ item: true }, { children: [_jsx(Chip, { label: dateTime, color: "primary", variant: "outlined", icon: _jsx(CalendarMonthIcon, {}, void 0), sx: { marginRight: '5px' } }, void 0), _jsx(Chip, { label: duration, color: "primary", variant: "outlined", icon: _jsx(TimerIcon, {}, void 0), sx: { marginRight: '5px' } }, void 0)] }), void 0), _jsxs(Grid, __assign({ item: true }, { children: [_jsx(IconButton, __assign({ color: "primary", onClick: function () { return _this.onDownloadAttachmentClick(video); }, sx: { marginRight: '5px' } }, { children: _jsx(SaveIcon, {}, void 0) }), void 0), ((_b = this.props.recordingStore) === null || _b === void 0 ? void 0 : _b.isRecording) ?
                                        null :
                                        _jsx(IconButton, __assign({ color: "primary", onClick: function () { return _this.onDeleteAttachmentClick(video); }, sx: { marginRight: '5px' } }, { children: _jsx(DeleteIcon, {}, void 0) }), void 0)] }), void 0)] }), void 0), _jsx(Grid, __assign({ item: true }, { children: _jsx("video", __assign({ controls: true, autoPlay: false, width: 355, height: 200, style: {
                                marginRight: '15px'
                            } }, { children: _jsx("source", { src: video.url }, void 0) }), void 0) }), void 0)] }), index));
        }
    });
    Object.defineProperty(VideoGallery.prototype, "renderEmpty", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return (_jsx("div", { children: "No recordings" }, void 0));
        }
    });
    Object.defineProperty(VideoGallery.prototype, "renderBusy", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return (_jsxs(Grid, __assign({ container: true, direction: "column", alignItems: "center", justifyContent: "center" }, { children: [_jsx(CircularProgress, {}, void 0), _jsx("span", __assign({ style: { marginTop: '10px' } }, { children: "Please wait" }), void 0)] }), void 0));
        }
    });
    Object.defineProperty(VideoGallery.prototype, "renderRecordingStatus", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a, _b;
            var duration = Duration.fromMillis((_b = (_a = this.props.recordingStore) === null || _a === void 0 ? void 0 : _a.durationMs) !== null && _b !== void 0 ? _b : 0);
            return (_jsxs("div", { children: ["Recording is in progress: ", duration.toFormat('mm:ss')] }, void 0));
        }
    });
    Object.defineProperty(VideoGallery.prototype, "onDownloadAttachmentClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (video) {
            window.open(video.url, '_blank');
        }
    });
    Object.defineProperty(VideoGallery.prototype, "onDeleteAttachmentClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (video) {
            this.setState(__assign(__assign({}, this.state), { deleteItemId: video.id }));
        }
    });
    Object.defineProperty(VideoGallery.prototype, "renderConfirmDeleteDialog", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            return (_jsxs(Dialog, __assign({ open: this.state.deleteItemId !== undefined, onClose: function () { return _this.onCloseConfirm(false); } }, { children: [_jsx(DialogTitle, { children: "Confirmation" }, void 0), _jsx(DialogContent, __assign({ sx: { minWidth: '300px' } }, { children: _jsx(Card, { children: _jsx(CardContent, { children: "Do you wish to delete this item?" }, void 0) }, void 0) }), void 0), _jsxs(DialogActions, { children: [_jsx(Button, __assign({ variant: "contained", color: "warning", onClick: function () { return _this.onCloseConfirm(true); } }, { children: "Yes" }), void 0), _jsx(Button, __assign({ variant: "outlined", onClick: function () { return _this.onCloseConfirm(false); } }, { children: "No" }), void 0)] }, void 0)] }), -1));
        }
    });
    Object.defineProperty(VideoGallery.prototype, "onCloseConfirm", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (isConfirmed) {
            var _a;
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!isConfirmed) return [3 /*break*/, 2];
                            return [4 /*yield*/, ((_a = this.props.recordingStore) === null || _a === void 0 ? void 0 : _a.delete(this.state.deleteItemId))];
                        case 1:
                            _b.sent();
                            _b.label = 2;
                        case 2:
                            this.setState(__assign(__assign({}, this.state), { deleteItemId: undefined }));
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    VideoGallery = __decorate([
        inject('languageStore'),
        inject('recordingStore'),
        observer
    ], VideoGallery);
    return VideoGallery;
}(React.Component));
export default VideoGallery;
